export default "__VITE_ASSET__BcO58MAT__"